// frontend/src/components/houses/ModalPago.jsx
import React, { useState } from 'react';
import { casasApi } from '../../services/api';

export default function ModalPago({ casa, onClose, onExito }) {
  const [form, setForm] = useState({
    monto:        '',
    metodoPago:   'TRANSFERENCIA',
    referencia:   '',
    fechaPago:    new Date().toISOString().slice(0, 10),
    notas:        '',
  });
  const [enviando, setEnviando] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.monto || parseFloat(form.monto) <= 0) {
      setErrorMsg('El monto debe ser mayor a 0.');
      return;
    }
    setEnviando(true);
    setErrorMsg(null);
    try {
      await casasApi.registrarPago(casa.casa_id, {
        monto:        parseFloat(form.monto),
        metodoPago:   form.metodoPago,
        referencia:   form.referencia,
        fechaPago:    form.fechaPago,
        notas:        form.notas,
        registradoPor: 'ADMIN',
      });
      onExito();
    } catch (err) {
      setErrorMsg(err.message);
    } finally {
      setEnviando(false);
    }
  };

  return (
    // Backdrop
    <div
      onClick={onClose}
      style={{
        position:'fixed', inset:0, background:'rgba(0,0,0,.4)',
        display:'flex', alignItems:'center', justifyContent:'center',
        zIndex:1000, padding:16,
      }}
    >
      {/* Modal */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background:'#fff', borderRadius:16, padding:28,
          width:'100%', maxWidth:440, boxShadow:'0 20px 60px rgba(0,0,0,.25)',
        }}
      >
        <h3 style={{ fontSize:17, fontWeight:700, color:'#1a3a5c', marginBottom:4 }}>
          💳 Registrar Pago
        </h3>
        <p style={{ fontSize:12, color:'#6b7280', marginBottom:20 }}>
          {casa.nombre_quinta} — {casa.propietario}
          <br/>
          Saldo pendiente:{' '}
          <strong style={{ color:'#dc2626' }}>
            ${parseFloat(casa.saldo_pendiente).toFixed(2)}
          </strong>
        </p>

        {errorMsg && (
          <div style={{ padding:'10px 14px', background:'#fef2f2',
                        color:'#dc2626', borderRadius:8, marginBottom:16, fontSize:13 }}>
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Monto */}
          <label style={labelStyle}>Monto (USD)*</label>
          <input
            type="number" step="0.01" min="0.01"
            value={form.monto} required
            onChange={e => set('monto', e.target.value)}
            style={inputStyle}
            placeholder={`Máx: ${parseFloat(casa.saldo_pendiente).toFixed(2)}`}
          />

          {/* Método */}
          <label style={labelStyle}>Método de Pago*</label>
          <select value={form.metodoPago}
                  onChange={e => set('metodoPago', e.target.value)}
                  style={inputStyle}>
            {['TRANSFERENCIA','EFECTIVO','CHEQUE','ZELLE','OTRO'].map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>

          {/* Referencia */}
          <label style={labelStyle}>N° de Referencia / Comprobante</label>
          <input
            type="text" value={form.referencia}
            onChange={e => set('referencia', e.target.value)}
            style={inputStyle} placeholder="Opcional"
          />

          {/* Fecha */}
          <label style={labelStyle}>Fecha de Pago*</label>
          <input
            type="date" value={form.fechaPago} required
            onChange={e => set('fechaPago', e.target.value)}
            style={inputStyle}
          />

          {/* Notas */}
          <label style={labelStyle}>Notas</label>
          <textarea
            value={form.notas}
            onChange={e => set('notas', e.target.value)}
            rows={2} placeholder="Observaciones opcionales…"
            style={{ ...inputStyle, resize:'vertical', fontFamily:'inherit' }}
          />

          <div style={{ display:'flex', gap:10, marginTop:20 }}>
            <button type="button" onClick={onClose}
                    style={{ ...btnSecundario, flex:1, padding:'10px' }}>
              Cancelar
            </button>
            <button type="submit" disabled={enviando}
                    style={{ ...btnPrimario, flex:2, padding:'10px',
                             opacity: enviando ? .7 : 1 }}>
              {enviando ? 'Procesando…' : '✅ Confirmar y Generar Recibo'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const labelStyle = {
  display:'block', fontSize:11, fontWeight:600,
  color:'#374151', marginBottom:4, marginTop:12,
};
const inputStyle = {
  width:'100%', padding:'9px 12px', borderRadius:8,
  border:'1px solid #d1d5db', fontSize:13, background:'#fff',
  color:'#374151', boxSizing:'border-box',
};
const btnPrimario  = {
  background:'#1a3a5c', color:'#fff', border:'none',
  borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:600,
};
const btnSecundario = {
  background:'#f3f4f6', color:'#374151', border:'none',
  borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500,
};
